function toggleDateInput(name) {
  var wrapper = $('.input__wrapper[data-form-input="' + name + '"]');
  var isDisabled = wrapper[0].hasAttribute('data-disabled');

  if (isDisabled) {
    wrapper.removeAttr('data-disabled');
    wrapper.find('[data-form-value]').removeAttr('disabled');
  } else {
    wrapper.attr('data-disabled', '');
    wrapper.find('[data-form-value]').attr('disabled', 'disabled');
  }
}
